import { ApiResponse, getRequest, postRequest } from "@/data/apiClient";

export interface MfaChannels {
  channels: {
    email: "user@org.co.uk";
    text: "+44 1234 567 890";
  };
}

export const getMfaChannels = async (
  clientKey: string
): Promise<ApiResponse<MfaChannels>> =>
  getRequest("user/mfa/list", { clientKey });

export const mfaSendCode = async (
  channel: string,
  clientKey: string
): Promise<ApiResponse<MfaChannels>> =>
  postRequest("user/mfa/send", { clientKey, channel });
